import { Directive, ElementRef, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { ModalController, PopoverController} from 'ionic-angular';

import { IonVirtualKeyboardComponent } from './ion-virtual-keyboard.component';

/**
 * Cerates an IonPpopover with the VirtualKayboard.
 *
 * @export
 * @class IonVirtualKeyboardPopover
 */
@Directive({
  selector: '[ion-virtual-keyboard-popover]'
})
export class IonVirtualKeyboardPopover{

    /**
     * Input for the popover title.
     *
     * @type {string}
     * @memberof IonVirtualKeyboardPopover
     */
    @Input('title') title: string = '';

    /**
     * Input for the keyborad layout.
     *
     * @type {string}
     * @memberof IonVirtualKeyboardPopover
     */
    @Input('layout') layout: string = 'numericKeyboard';

    /**
     * Default value.
     *
     * @type {string}
     * @memberof IonVirtualKeyboardPopover
     */
    @Input('value') value: string = '';

    /**
     * Output EventEmitter when input is accepted.
     *
     * @type {EventEmitter<string>}
     * @memberof IonVirtualKeyboardPopover
     */
    @Output('setVKValue') setVKValue: EventEmitter<string> = new EventEmitter();


    /**
     * Mask of the text input.
     *
     * @memberof IonVirtualKeyboardPopover
     */
    @Input('mask') mask = '';

    numericKeyboard: any = [
        ['1', '2', '3', 'Backspace:2'],
        ['4', '5', '6', 'Spacer:2'],
        ['7', '8', '9', 'Spacer:2'],
        ['Spacer', '0', 'Spacer:3'],
      ];


    /**
     * Contains a reference to the input element.
     *
     * @type {*}
     * @memberof IonVirtualKeyboardPopover
     */
    element: any = false;



    /**
     * Creates an instance of IonVirtualKeyboardPopover.
     * 
     * @param {ElementRef} element //Reference of the element.
     * @param {ModalController} _modalCtrl //Ionic modal controller.
     * @param {PopoverController} _popoverCtrl ///Ionic popover controller.
     * @memberof IonVirtualKeyboardPopover
     */
    constructor(
        element: ElementRef,
        private _modalCtrl: ModalController,
        private _popoverCtrl: PopoverController
    ){
        this.element = element;
    }


    /**
     * Listen input focus events.
     *
     * @param {*} target
     * @memberof IonVirtualKeyboardPopover
     */
    @HostListener('ionFocus', ['$event'])
    onFocus(target) {
        this.openPopover();
    }

    /**
     * Listen click events.
     *
     * @param {*} target
     * @memberof IonVirtualKeyboardPopover
     */
    @HostListener('click', ['$event'])
    click(target) {
        this.openPopover();
    }

    /**
     *Open the Ionic popover.
     *
     * @memberof IonVirtualKeyboardPopover
     */
    openPopover(){
        //Get inner input of an ion-item
        let el =  this.element.nativeElement.getElementsByTagName('input')[0];

        //Pass a new ElementRef to component
        let vkModal = this._popoverCtrl.create(
            IonVirtualKeyboardComponent,
            {
                input: new ElementRef(el),
                layout: this.layout,
                value: this.value,
                title: this.title,
                mask: this.mask
            },
            {
                cssClass: 'virtual-keyboard-popover'
            }
        );

        //Transmit popover value
        vkModal.onDidDismiss((data,role) =>{
            if(data) this.setVKValue.emit(data.value);
        });
        vkModal.present();
    }
}


// WEBPACK FOOTER //
// ./src/modules/utils/ion-virtual-keyboard/ion-virtual-keyboard.popover.ts